import { doAjax } from '../utils';
import imgPerson from 'src/img/misc/person.png';
import imgTransparentPixel from 'src/img/public/spacer.gif';

const getMapiUrl = (email, mapiHost) => `//${mapiHost}/v2/mailbox/${email}/folders/recent`;

const templates = {
    item: ({ email, imgSrc }, urlParts, id) => {
        const linkParts = [...urlParts];
        linkParts.splice(1, 0, email);

        return `
            <li class="account">
                <a class="account__link" href="${linkParts.join('')}">
                    <span class="account__avatar">
                        <img
                            alt="Avatar"
                            class="img-circle"
                            data-fallback="${imgPerson}"
                            data-src="${imgSrc}"
                            id="linked-avatar_${id}"
                            src="${imgTransparentPixel}"
                        />
                        <i class="indicator" data-user="${email}"></i>
                    </span>
                    ${email}
                </a>
            </li>
        `;
    },
    itemsList: (items) => `
        <ul class="accounts-list">
            ${items}
        </ul>
    `,
    addAcount: (obj) => `
        <div class="account">
            <a class="account__link account__link_add" href="${obj.urlParts[0]}">
                <span class="ico ipi-plus"></span>
                ${obj.i18n}
            </a>
        </div>
    `,
};

const renderAccounts = (obj, classes) => {
    // console.log(obj);
    const { linkedAccounts, selectors } = obj;
    const container = document.getElementById(selectors.accountsContainer);

    if (obj.linkedAccounts.length < 1) {
        container.innerHTML = templates.addAcount(obj);
        return;
    }

    const items = linkedAccounts.map((item, idx) => templates.item(item, obj.urlParts, idx)).join('');
    container.innerHTML = templates.itemsList(items) + templates.addAcount(obj);
    const images = container.querySelectorAll('img');

    for (const image of images) {
        const avatarInstance = classes.Avatar(`#${image.id}`);
        avatarInstance.check();
    }

    // Check recent
    doAjax({ url: getMapiUrl(obj.email, obj.mapiHost) })
        .then((response) => {
            const { linkedUsers } = response;
            for (const user of linkedUsers) {
                const { hasRecent, username } = user;
                const indicator = container.querySelector(`[data-user="${username}"]`);
                indicator.classList.toggle('on', hasRecent);
            }
        })
        .catch((/* err */) => {
            // console.log(err);
        });
};

export default (obj, INBOX) => {
    // Lazy load linked account images - only when sidebar is opened
    INBOX.observer.observe('sideMenuOpen', (e, isOpen) => {
        if (isOpen) renderAccounts(obj, INBOX.classes);
    });
};
